<!--事件处理-执法处理-->
<template>
  <section>
    <!-- 工具条 -->
    <el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filter" size="mini">
          <el-form-item>
            <el-input
              v-model="filter.val"
              placeholder="标题搜索"
              @keyup.native.enter="handleFilterChange"
              clearable
              @clear="handleFilterChange"
            />
          </el-form-item>
          <el-form-item>
            <el-cascader
              placeholder="所属单位"
              @change="handleFilterChange"
              v-model="filter.owner"
              :options="customerTree"
              :props="customerProps"
              clearable
              filterable/>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="filter.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00','23:59:59']"
              @change="handleFilterChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.type"
              filterable
              clearable
              placeholder='文章类型'
            >
              <template v-for="item in typeList">
                <el-option :value="item.id" :label="item.name"/>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleAdd()"
            >新增
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-row>
      <el-col :span="24">
        <el-table
          :data="datalist.content"
          size="mini"
          border
          highlight-current-row
          v-loading="loading"
          :max-height="clientHeight"
          style="width: 100%"
        >
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
            prop="title"
            label="文章标题"
            width="160"
            align="center"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            prop="name"
            label="上传人"
            width="160"
            align="center"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            prop="owner_name"
            label="所属单位"
            align="center"
            width="300"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            prop="type_name"
            label="文章类型"
            align="center"
            width="160"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            prop="create_at"
            label="创建时间"
            align="center"
            width="160"
            show-overflow-tooltip
            header-align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="200"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text" size="mini"
                @click="handleEditRow(scope.row)"
              >编辑
              </el-button>

              <el-button
                type="text" size="mini" style="color:#ee0000;"
                @click="handleDelete(scope.row)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 工具条 -->
    <div class="toolbar">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filter.page"
        :page-sizes="filter.pageSizes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="datalist.total"
        style="display: inline-block; margin-left: 15px;margin-top:12px;"
      ></el-pagination>
    </div>
    <ArticleDialogEditRow ref="articleDialogEditRow" @on-refresh="getData" />
  </section>
</template>

<script>
import ArticleDialogEditRow from "@/component/ArticleDialogEditRow"
import {mapState} from 'vuex'
import {
  getUserInfo,
  ownerJoin
} from '@/util'


export default {
  name: 'HeartService',
  components: {ArticleDialogEditRow},
  data() {
    return {
      loading: false,
      datalist: {},
      typeList: [],
      userInfo: null,
      filter: {
        val: null,
        owner: null,
        dateRange: null,
        type: '',
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
    }
  },
  computed: {
    ...mapState({
      customerProps: state => Object.assign({}, state.props, {label: 'Org', checkStrictly: true})
    }),
    ...mapState(['props', 'clientHeight', 'customerTree', 'locale', 'user'])
  },
  async created() {
    this.userInfo = getUserInfo().Info
    await this.getTypes()
    this.getData()
  },
  methods: {
    async getTypes() {
       this.$get('admin/plat_message/type', {}).then(res => {
        this.typeList = res.list
      })
    },
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true
      const payload = {
        page: this.filter.page,
        size: this.filter.size,
        type: this.filter.type ? this.filter.type : '',
      }
      if (this.filter.owner && this.filter.owner.length > 0) {
        const owner = `${ownerJoin(this.filter.owner, this.userInfo)}`
        payload.owner = owner
      }
      //关键字搜索
      if (this.filter.val) {
        payload.name = this.filter.val
      }
      //日期范围选择
      if (this.filter.dateRange) {
        payload.start_time = this.filter.dateRange[0].getTime() / 1000
        payload.end_time = this.filter.dateRange[1].getTime() / 1000
      }
      this.$get('admin/plat_message', payload).then(res => {
        this.datalist.content = res.list
        this.datalist.total = res.count
        this.loading = false
      })
    },
    handleRefresh() {
      this.filter.page = 1
      this.getData()
    },
    // 改变页容量
    handleSizeChange(size) {
      this.filter.size = size
      this.getData()
    },
    // 翻页
    handleCurrentChange(page) {
      this.filter.page = page
      this.getData()
    },
    handleEditRow(row) {
      this.$refs['articleDialogEditRow'].dealDialog('edit', { ...row })
    },
    handleAdd() {
      this.$refs['articleDialogEditRow'].dealDialog('add', { })
    },
    async handleDelete(row) {
      const { id, title } = row
      this.$confirm(`您正在删除【${title}】,是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.$post('admin/plat_message/delete/' + row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          setTimeout(()=> {
            this.getData()
          }, 500)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
